type Props = {
  currentQuestion: any;
};

const SliderPreview = ({ currentQuestion }: Props) => {
  const { responses } = currentQuestion;
  return (
    <div style={{ fontSize: "14px" }}>{responses?.[0]?.numberValue || ""}</div>
  );
};
export default SliderPreview;
